// Single source of truth for where each role lands after login. Used by both App.tsx
// (route redirect) and LoginPage.tsx (post-login navigate) so they cannot diverge.
export type Role = 'AUCTIONEER' | 'BIDDER' | 'SUPERADMIN';

export function homePathForRole(role: Role | string): string {
  switch (role) {
    case 'AUCTIONEER':
      return '/auctioneer';
    case 'SUPERADMIN':
      return '/admin';
    default:
      return '/bidder';
  }
}
